import { GqlMapShapeIcon } from "~/__generated__";
import mapShapeIconCircle from "~/assets/images/icons/map_shape_icon_circle.svg";
import mapShapeIconDiamond from "~/assets/images/icons/map_shape_icon_diamond.svg";
import mapShapeIconHexagon from "~/assets/images/icons/map_shape_icon_hexagon.svg";
import mapShapeIconPentagon from "~/assets/images/icons/map_shape_icon_pentagon.svg";
import mapShapeIconPlus from "~/assets/images/icons/map_shape_icon_plus.svg";
import mapShapeIconSquare from "~/assets/images/icons/map_shape_icon_square.svg";
import mapShapeIconStarFive from "~/assets/images/icons/map_shape_icon_star_five.svg";
import mapShapeIconStarFour from "~/assets/images/icons/map_shape_icon_star_four.svg";
import mapShapeIconStarSix from "~/assets/images/icons/map_shape_icon_star_six.svg";
import mapShapeIconStarThree from "~/assets/images/icons/map_shape_icon_star_three.svg";
import mapShapeIconTriangleDown from "~/assets/images/icons/map_shape_icon_triangle_down.svg";
import mapShapeIconTriangleUp from "~/assets/images/icons/map_shape_icon_triangle_up.svg";

export const MAP_SHAPE_ICON_IMAGE_IDS: Record<GqlMapShapeIcon, string> = {
    [GqlMapShapeIcon.Square]: "mapShapeIconSquare",
    [GqlMapShapeIcon.TriangleUp]: "mapShapeIconTriangleUp",
    [GqlMapShapeIcon.TriangleDown]: "mapShapeIconTriangleDown",
    [GqlMapShapeIcon.Circle]: "mapShapeIconCircle",
    [GqlMapShapeIcon.Pentagon]: "mapShapeIconPentagon",
    [GqlMapShapeIcon.Diamond]: "mapShapeIconDiamond",
    [GqlMapShapeIcon.Hexagon]: "mapShapeIconHexagon",
    [GqlMapShapeIcon.Plus]: "mapShapeIconPlus",
    [GqlMapShapeIcon.StarThree]: "mapShapeIconStarThree",
    [GqlMapShapeIcon.StarFour]: "mapShapeIconStarFour",
    [GqlMapShapeIcon.StarFive]: "mapShapeIconStarFive",
    [GqlMapShapeIcon.StarSix]: "mapShapeIconStarSix",
};

export const MAP_SHAPE_ICON_FILES: Record<GqlMapShapeIcon, string> = {
    [GqlMapShapeIcon.Square]: mapShapeIconSquare,
    [GqlMapShapeIcon.TriangleUp]: mapShapeIconTriangleUp,
    [GqlMapShapeIcon.TriangleDown]: mapShapeIconTriangleDown,
    [GqlMapShapeIcon.Circle]: mapShapeIconCircle,
    [GqlMapShapeIcon.Pentagon]: mapShapeIconPentagon,
    [GqlMapShapeIcon.Diamond]: mapShapeIconDiamond,
    [GqlMapShapeIcon.Hexagon]: mapShapeIconHexagon,
    [GqlMapShapeIcon.Plus]: mapShapeIconPlus,
    [GqlMapShapeIcon.StarThree]: mapShapeIconStarThree,
    [GqlMapShapeIcon.StarFour]: mapShapeIconStarFour,
    [GqlMapShapeIcon.StarFive]: mapShapeIconStarFive,
    [GqlMapShapeIcon.StarSix]: mapShapeIconStarSix,
};

export const MAP_SHAPE_ICONS: { file: string; id: string }[] = [
    { file: mapShapeIconSquare, id: MAP_SHAPE_ICON_IMAGE_IDS[GqlMapShapeIcon.Square] },
    { file: mapShapeIconTriangleUp, id: MAP_SHAPE_ICON_IMAGE_IDS[GqlMapShapeIcon.TriangleUp] },
    { file: mapShapeIconTriangleDown, id: MAP_SHAPE_ICON_IMAGE_IDS[GqlMapShapeIcon.TriangleDown] },
    { file: mapShapeIconCircle, id: MAP_SHAPE_ICON_IMAGE_IDS[GqlMapShapeIcon.Circle] },
    { file: mapShapeIconPentagon, id: MAP_SHAPE_ICON_IMAGE_IDS[GqlMapShapeIcon.Pentagon] },
    { file: mapShapeIconDiamond, id: MAP_SHAPE_ICON_IMAGE_IDS[GqlMapShapeIcon.Diamond] },
    { file: mapShapeIconHexagon, id: MAP_SHAPE_ICON_IMAGE_IDS[GqlMapShapeIcon.Hexagon] },
    { file: mapShapeIconPlus, id: MAP_SHAPE_ICON_IMAGE_IDS[GqlMapShapeIcon.Plus] },
    { file: mapShapeIconStarThree, id: MAP_SHAPE_ICON_IMAGE_IDS[GqlMapShapeIcon.StarThree] },
    { file: mapShapeIconStarFour, id: MAP_SHAPE_ICON_IMAGE_IDS[GqlMapShapeIcon.StarFour] },
    { file: mapShapeIconStarFive, id: MAP_SHAPE_ICON_IMAGE_IDS[GqlMapShapeIcon.StarFive] },
    { file: mapShapeIconStarSix, id: MAP_SHAPE_ICON_IMAGE_IDS[GqlMapShapeIcon.StarSix] },
];
